import { render, staticRenderFns } from "./ReturnConfirmation.vue?vue&type=template&id=6a5eb8d6&scoped=true&"
import script from "./ReturnConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReturnConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ReturnConfirmation.vue?vue&type=style&index=0&id=6a5eb8d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5eb8d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/jamievetrovsky/Documents/WorkDevelopment/product-return-portal-fe/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VLayout})
